module.exports = __webpack_public_path__ + "img/13.2163b36a.webp";